import { Navigate } from "react-router-dom";

function OtpRouteGuard({ children }) {
  const mobileNo = localStorage.getItem("mobile_no");
  if (!mobileNo) {
    return <Navigate to="/login" replace />;
  }
  return children;
}

export default OtpRouteGuard;
